import React from "react";
import "./MobileTabletTimesheets.css";
import { Link } from "react-router-dom";
import TimesheetStatus from "../TimesheetStatus/TimesheetStatus";
import { parseHours } from "../../../helpers/time";
import { calculateTimesheetStatus } from "../helpers/helpers";
import LabeledValue from "../../common/LabeledValue/LabeledValue";

const MobileTabletTimesheets = ({
  className,
  setTimesheet,
  sortedRows,
  togglePopup,
  isDayType
}) =>
  sortedRows.map(row => (
    <div className={`${className} timesheets-tablet__wrapper`}>
      <div className={`timesheets-tablet__grid`}>
        <div className="timesheets-tablet__grid-elem">
          <h4>{row.candidateName}</h4>
          <div>
            <LabeledValue
              label="job title"
              value={`${row.jobTitle}`}
              isBold={false}
            />
          </div>
        </div>
        <div className="timesheets-tablet__grid-elem">
          <TimesheetStatus status={calculateTimesheetStatus(row)} />
          {row.authorisedBy && (
            <LabeledValue
              className="timesheets-tablet__jobtitle"
              label="approved by"
              value={`${row.authorisedBy}`}
              isBold={false}
            />
          )}
        </div>
        <div className="timesheets-tablet__grid-elem">
          <LabeledValue
            label="charge"
            value={`£${row.totalInvoiceAmount.toFixed(2)}`}
            isBold={false}
          />
          {isDayType ? (
            <LabeledValue
              label="days"
              value={`${parseHours(row.rowTotaledHours).split("h")[0]} days`}
              isBold={false}
            />
          ) : (
            <LabeledValue
              label="hours"
              value={parseHours(row.rowTotaledHours)}
              isBold={false}
            />
          )}
        </div>
        <div className="timesheets-tablet timesheets-tablet__grid-elem">
          <div className="d-flex flex-row-reverse">
            <Link
              to={{
                pathname: `/timesheets/${row.timesheetRef}`,
                state: {
                  sortedTimesheetRefs: sortedRows.map(sr => sr.timesheetRef)
                }
              }}
            >
              <button className="btn btn-primary timesheets__viewButton">
                View timesheet
              </button>
            </Link>
            <span
              className="timesheets__summaryButton timesheets-tablet__summaryButton"
              onClick={() => {
                setTimesheet(row);
                togglePopup();
              }}
            >
              Summary
            </span>
          </div>
        </div>
      </div>
    </div>
  ));

export default MobileTabletTimesheets;
